import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { Badge } from '@ionic-native/badge/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@NgModule({
  	declarations: [AppComponent],
  	entryComponents: [],
  	imports: [
  		BrowserModule, 
  		IonicModule.forRoot(), 
  		AppRoutingModule, 
  		HttpClientModule
  	],
  	providers: [
  		SplashScreen,
  		StatusBar,
  		OneSignal,
  		Badge,
  		CallNumber,
  		Camera,
  		InAppBrowser,
  		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  	],
  	bootstrap: [AppComponent]
})
export class AppModule {}
